<template>
	<Transition name="down">
		<div class="xtx-message" v-show="visible">
			<span class="text" v-html="text"></span>
		</div>
	</Transition>

</template>
<script>
	import {
		ref,
		onMounted
	} from 'vue'
	export default {
		name: 'XtxMessage',
		props: {
			text: {
				type: String,
				default: ''
			},
			type: {
				type: String,
				// warn 警告  error 错误  success 成功
				default: 'warn'
			}
		},
		setup() {
			// 定义一个对象，包含三种情况的样式，对象key就是类型字符串
			const visible = ref(false);
			onMounted(() => {
				visible.value = true
			})
			return {
				visible
			}
		}
	}
</script>
<style scoped lang="scss">
	.xtx-message {
		max-width: 300px;
		min-width: 100px;

		position: fixed;
		z-index: 999999;
		left: 50%;
		top: 45%;
		line-height: 1.5;
		padding: 10px 25px;
		background: rgba(0, 0, 0, .6);
		color: #ffffff;
		border-radius: 4px;
		transform: translate(-50%, -50%) scale(1);

		i {
			margin-right: 4px;
			vertical-align: middle;
		}

		.text {
			vertical-align: middle;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	.down-enter-from {
		opacity: 0;
		transform: translate(-50%, -50%) scale(0);
	}

	.down-enter-active {
		transition: all 0.3s;
	}

	.down-enter-to {
		transform: translate(-50%, -50%) scale(1);
		opacity: 1;
	}
</style>